import axios from 'axios';

const SIM_SWAP_BASE_URL = process.env.REACT_APP_SIM_SWAP_BASE_URL;
const SIM_SWAP_AUTH = process.env.REACT_APP_SIM_SWAP_AUTH;

if (!SIM_SWAP_BASE_URL || !SIM_SWAP_AUTH) {
  // eslint-disable-next-line no-console
  console.error(
    'SIM Swap is misconfigured: REACT_APP_SIM_SWAP_BASE_URL and REACT_APP_SIM_SWAP_AUTH must be set at build time. ' +
      'Add them to GitLab CI/CD variables and to your local .env.'
  );
}

const simSwapClient = axios.create({
  baseURL: SIM_SWAP_BASE_URL,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
    ...(SIM_SWAP_AUTH ? { Authorization: SIM_SWAP_AUTH } : {}),
  },
});

export const postNumberSwapBindings = (bindings, { onUploadProgress } = {}) =>
  simSwapClient.post('/api/v1/number-swap/bindings', bindings, { onUploadProgress });

export const getNumberSwapBindings = (params, { signal } = {}) =>
  simSwapClient.get('/api/v1/number-swap/bindings', { params, signal });
